import { checkDebugSecret } from 'page/SystemConfig'

/**
 * This util transform external url into url that goes through proxy,
 * It is a no op in production environment
 * @param {string} url
 * @returns {string}
 */
export const processURL = /*#__PURE__*/ (url) => {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_DEV_ENABLE_PROXY) {
    if (/^https?:\/\//.test(url)) {
      return url.replace(/^https?:\/\//, '/server_proxy/')
    }
  }

  return url
}

export const getDebugInfo = () => {
  try {
    const temp = JSON.parse(localStorage.getItem('DEBUG'))
    if (Array.isArray(temp) && temp.every((i) => typeof i === 'string')) {
      if (checkDebugSecret(temp[0])) {
        return temp.slice(1)
      }
    }
  } catch (err) {}

  return []
}
